import {Avatar, Col, Divider, Layout, Row, theme, Typography} from "antd";
import React from "react";
import ResponsiveHeader from "../components/ResponsiveHeader";
import hekimJpg from "../assets/Hekim.jpg";
import "./Home.css"

const {Content} = Layout;
const {Text, Link, Title, Paragraph} = Typography;
const {useToken} = theme;

function Home() {
    const {token} = useToken();

    return (
        <Layout style={{minHeight: "100vh"}}>
            <ResponsiveHeader/>
            <Content className="site-layout"
                     style={{
                         margin: '16px 0',
                         padding: 16,
                         maxWidth: '1200px',
                         width: "100%",
                         alignSelf: "center",
                         background: token.colorBgContainer
                     }}>
                <Row>
                    <Col xs={24} lg={6} style={{display: "inline-grid"}}>
                        <Avatar src={<img src={hekimJpg} alt="avatar"/>}
                                style={{maxWidth: "256px", width: "100%", height: "auto", placeSelf: "center"}}/>
                    </Col>
                    <Col xs={24} lg={{span: 17, offset: 1}} style={{display: "inline-grid"}}>
                        <Title style={{color: token.colorPrimaryText, placeSelf: "center"}}>
                            David Hekim
                        </Title>
                        <Paragraph>
                            Site Reliability Engineer with a strong educational and professional background
                            including <Text strong>7+ years</Text> of experience in Software Development and DevOps
                            roles. Skilled in designing and maintaining robust monitoring, observability and search
                            applications to ensure high availability and optimized performance. Demonstrated track
                            record of success in developing efficient and scalable solutions, leveraging agile
                            methodologies, and collaborating within cross-functional teams to deliver high-quality
                            projects. Seeking a challenging engineering role to contribute technical expertise and
                            drive innovative software solutions.
                        </Paragraph>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col span={24} className={"responsiveCol"}>
                        <Title level={3} style={{color: token.colorPrimaryText, marginBottom: 0}}>
                            EXPERIENCE
                        </Title>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginTop: 0, borderBlockStartColor: token.colorPrimaryText}}/>
                    </Col>

                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Text strong>
                            Senior DevOps Engineer
                        </Text>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Oct 2020 – Present
                        </Text>
                    </Col>
                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Link href={"https://tech.allianz.com/en.html"} target="_blank"
                              style={{color: token.colorPrimaryText}}>
                            Allianz Technology SE
                        </Link>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Munich, Germany
                        </Text>
                    </Col>
                    <Col span={24}>
                        <Paragraph>
                            <ul>
                                <li>
                                    Researched and developed an end-to-end scalable observability platform from
                                    scratch, leveraging the ELK-stack, Grafana and Prometheus, able to handle over 726
                                    million logs per day and reducing MTTR for P1 incidents by 50%.
                                </li>
                                <li>
                                    Migrated legacy EOL monolith to multi-region cloud infrastructure application with
                                    automated disaster recovery failover using Terraform, achieving 99.99% uptime while
                                    lowering costs through auto-scaling and rightsizing of instances.
                                </li>
                                <li>
                                    Promoted DevSecOps culture by automating vulnerability scans and centralizing
                                    secrets with Vault in the CI/CD pipeline.
                                </li>
                                <li>
                                    Mentored engineers in best-practice workshops; promoted cross-functional
                                    collaboration with QA and product teams.
                                </li>
                            </ul>
                        </Paragraph>
                    </Col>

                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Text strong>
                            Java Software Developer during Dual Study Program
                        </Text>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Sep 2017 – Sep 2020
                        </Text>
                    </Col>
                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Link href={"https://www.allianz.de/unternehmen/"} target="_blank"
                              style={{color: token.colorPrimaryText}}>
                            Allianz Deutschland AG
                        </Link>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Unterföhring, Germany
                        </Text>
                    </Col>
                    <Col span={24}>
                        <Paragraph>
                            <ul>
                                <li>
                                    Engineered and deployed an application to securely organize on-call shifts across
                                    over 80 teams, leveraging Agile sprints.
                                </li>
                                <li>
                                    Upgraded apps from Java 8, facilitating the adoption of modularization without
                                    disruptions for over 5500 employees.
                                </li>
                                <li>
                                    Boosted application throughput by 35% and cut response times in half by
                                    implementing caching strategies with Redis.
                                </li>
                                <li>
                                    Instrumented applications with OpenTelemetry / Jaeger tracing, cutting
                                    troubleshooting time by an average of 30%.
                                </li>
                            </ul>
                        </Paragraph>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col span={24} className={"responsiveCol"}>
                        <Title level={3} style={{color: token.colorPrimaryText, marginBottom: 0}}>
                            EDUCATION
                        </Title>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginTop: 0, borderBlockStartColor: token.colorPrimaryText}}/>
                    </Col>

                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Text strong>
                            Master of Science (M.Sc.) Informatics
                        </Text>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Oct 2020 – Oct 2022
                        </Text>
                    </Col>
                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Link href={"https://www.tum.de/en/"} target="_blank" style={{color: token.colorPrimaryText}}>
                            Technical University Munich
                        </Link>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Garching, Germany
                        </Text>
                    </Col>
                    <Col span={24}>
                        <Paragraph>
                            <ul>
                                <li>
                                    Major in Computer Architecture, Computer Networks and Distributed Systems
                                </li>
                                <li>
                                    Minor in Engineering Software-intensive Systems
                                </li>
                                <li>
                                    Thesis: Application Specific Observability of an IoT Platform in the Cloud
                                </li>
                            </ul>
                        </Paragraph>
                    </Col>

                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Text strong>
                            Bachelor of Science (B.Sc.) Computer Science
                        </Text>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Oct 2017 – Sep 2020
                        </Text>
                    </Col>
                    <Col xs={24} sm={16} className={"responsiveColLeft"}>
                        <Link href={"https://www.unibw.de/home-en"} target="_blank"
                              style={{color: token.colorPrimaryText}}>
                            University of the Federal Armed Forces Munich
                        </Link>
                    </Col>
                    <Col xs={24} sm={8} className={"responsiveColRight"}>
                        <Text>
                            Neubiberg, Germany
                        </Text>
                    </Col>
                    <Col span={24}>
                        <Paragraph>
                            <ul>
                                <li>
                                    Mathematics specialization
                                </li>
                                <li>
                                    Thesis: Development of a Java Module for Processing Architecture Data of Neural
                                    Networks
                                </li>
                            </ul>
                        </Paragraph>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col span={24} className={"responsiveCol"}>
                        <Title level={3} style={{color: token.colorPrimaryText, marginBottom: 0}}>
                            SKILLS
                        </Title>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginTop: 0, borderBlockStartColor: token.colorPrimaryText}}/>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>Key Competencies:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>Automation, Cost Efficiency, Latency Optimization, Monitoring, Reliability, Scalability,
                            Security</Text>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>Programming:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>Java, Python, Scala, Ruby, JavaScript, TypeScript</Text>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>CI/CD:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>Ansible, Docker, Jenkins, Kubernetes, Vault, Git, GitHub Actions, Terraform</Text>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>Cloud:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>Google Cloud Platform (GCP), Amazon Web Services (AWS), Microsoft Azure</Text>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>Monitoring:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>ElasticSearch, OpenSearch, Logstash, Kibana, Grafana, Prometheus, Jaeger, Zipkin,
                            Dynatrace</Text>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>Data:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>Kafka, Pub/Sub, Redis, Firebase, MQTT, IBM DB2, MySQL, MariaDB, PostgreSQL, NoSQL,
                            MongoDB</Text>
                    </Col>

                    <Col xs={24} lg={4} className={"responsiveCol"}>
                        <Text strong>Languages:</Text>
                    </Col>
                    <Col xs={24} lg={20} className={"responsiveCol"}>
                        <Text>German (Native), Aramaic (Native), English (Professional proficiency – TOEFL certified),
                            Japanese (Learning)</Text>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col span={24} className={"responsiveCol"}>
                        <Title level={3} style={{color: token.colorPrimaryText, marginBottom: 0}}>
                            ACTIVITIES
                        </Title>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginTop: 0, borderBlockStartColor: token.colorPrimaryText}}/>
                    </Col>

                    <Col span={24}>
                        <Paragraph>
                            <Text strong>Achievements:</Text>
                            <ul>
                                <li>
                                    Placed 1st student team among 141 teams at the UniBw CTF
                                </li>
                                <li>
                                    Oracle Certified Java EE Associate
                                </li>
                                <li>
                                    Honored by the German Informatics Society for outstanding performance in school
                                </li>
                                <li>
                                    Contributor to OpenSearch security plugin
                                </li>
                                <li>
                                    Won highest prize money at GFOS coding competition
                                </li>
                            </ul>
                        </Paragraph>
                        <Paragraph>
                            <Text strong>Interests:</Text>
                            <ul>
                                <li>
                                    Capture the Flag (CTF) competitions
                                </li>
                                <li>
                                    Hackathons
                                </li>
                                <li>
                                    Home automation
                                </li>
                                <li>
                                    Open Source
                                </li>
                                <li>
                                    Sudoku
                                </li>
                                <li>
                                    Basketball
                                </li>
                                <li>
                                    Strategy Gaming
                                </li>
                            </ul>
                        </Paragraph>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Home;
